<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">
            <div class="text-center mt-5">
              <h3>پیام خصوصی</h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>راهی برای به اشتراک‌گذاری پیام به
                صورت امن با دیگران
              </div>

              <div class="h6 mt-4" style="text-align: right">ایجاد یک پیام خصوصی جدید</div>

              <base-input class="mb-4">
                <textarea v-model="text" class="form-control form-control-alternative" cols="80"
                          name="name" placeholder="متن پیام" rows="6"></textarea>
              </base-input>

              <br>

              <div v-show="showMore">

                <div class="container ct-example-row">
                  <div class="row">

                    <div class="text-primary" style="font-size: large; margin-bottom: 4px; margin-top: 16px">طول عمر
                      پیام
                    </div>
                    <div class="w-100"></div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">مدت انقضاء</small>
                      <base-dropdown>
                        <base-button slot="title" class="dropdown-toggle" type="secondary">
                          {{ expireString }}
                        </base-button>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(1)">{{ expireHoursList[1] }}</a>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(6)">{{ expireHoursList[6] }}</a>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(24)">{{ expireHoursList[24] }}</a>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(72)">{{ expireHoursList[72] }}</a>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(168)">{{ expireHoursList[168] }}</a>
                        <a class="dropdown-item" href="#"
                           @click.prevent="onDropDownClick(336)">{{ expireHoursList[336] }}</a>
                      </base-dropdown>

                    </div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">تعداد نمایش</small>
                      <base-input v-model="viewCount" alternative placeholder="تعداد نمایش"/>
                    </div>

                    <div class="w-100"></div>
                    <div class="text-primary" style="font-size: large; margin-bottom: 4px; margin-top: 16px">گذرواژه
                    </div>
                    <div class="w-100"></div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">یک گذرواژه دلخواه برای قفل کردن پیام وارد
                        کنید</small>
                      <base-input v-model="password" alternative placeholder="گذرواژه دلخواه" type="password"/>
                    </div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">تکرار گذرواژه</small>
                      <base-input v-model="passwordConfirmation" alternative placeholder="تکرار گذرواژه"
                                  type="password"/>
                    </div>

                    <div class="w-100"></div>
                    <div class="text-primary" style="font-size: large; margin-bottom: 4px; margin-top: 16px">اعلان
                      تخریب
                    </div>
                    <div class="w-100"></div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">آدرس ایمیل برای اطلاع از اعلان منقضی شدن
                        پیام</small>
                      <base-input v-model="email" alternative placeholder="آدرس ایمیل"/>
                    </div>

                    <div class="col-lg-6 col-sm-6">
                      <small class="d-block text-uppercase font-weight-bold mb-2"
                             style="text-align: right; margin-top: 8px">عنوان دلخواه برای اعلان ایمیل</small>
                      <base-input v-model="emailTitle" alternative placeholder="عنوان"/>
                    </div>

                  </div>
                </div>

                <br/>
              </div>

              <base-alert v-if="showError" icon="ni ni-support-16" type="danger">
                <span slot="text"><strong>خطا! </strong>{{ error }}</span>
              </base-alert>

              <base-button type="neutral" @click="showMore=!showMore">
                {{ showMore ? "پنهان کردن تنظیمات پیشرفته" : "نمایش تنظیمات پیشرفته" }}
              </base-button>
              <base-button type="primary" @click="createMessage">ایجاد پیام</base-button>
              <div/>
              <br>

            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
import BaseDropdown from "../components/BaseDropdown";
import axios from "axios";

export default {
  components: {
    Inputs,
    BaseDropdown
  },
  data() {
    return {
      showMore: false,
      text: '',
      expireHoursList: {
        1: '۱ ساعت',
        6: '۶ ساعت',
        24: '۱ روز',
        72: '۳ روز',
        168: '۷ روز',
        336: '۱۴ روز'
      },
      expireHours: 24,
      expireString: '۱ روز',
      viewCount: 1,
      password: '',
      passwordConfirmation: '',
      email: '',
      emailTitle: '',
      showError: false,
      error: '',
    }
  },
  methods: {
    createMessage() {
      let canContinue = true;
      this.showError = false

      if (this.text === '') {
        this.error = 'متن نمی‌تواند خالی باشد'
        this.showError = true
        canContinue = false;
      } else if (this.password !== this.passwordConfirmation) {
        this.error = 'گذرواژه‌های وارد شده همخوانی ندارند'
        this.showError = true
        canContinue = false;
      }

      if (canContinue) {
        const formData = new FormData()
        formData.append('t', this.text)
        formData.append('eat', this.expireHours)
        formData.append('eanov', this.viewCount)
        formData.append('mp', this.password)
        formData.append('dne', this.email)
        formData.append('dnt', this.emailTitle)

        const headers = {'Content-Type': 'multipart/form-data'}
        axios.post(`${process.env.VUE_APP_API_ROOT}/create-private-message_v1`, formData, {headers})
            .then(res => {
              if (res.status === 200) {
                if (res.data.r === 1) {
                  this.$router.push({name: 'share', params: {hash: res.data.h}})
                } else {
                  this.error = 'متاسفانه خطایی پیشبینی نشده رخ داد'
                  this.showError = true
                }
              } else {
                this.error = 'متاسفانه خطایی رخ داد'
                this.showError = true
              }
            })

      }
    },
    onDropDownClick(hours) {
      this.expireHours = hours;
      this.expireString = this.expireHoursList[hours]
      return false;
    }

  }
};
</script>

<style scoped>

.dropdown {
  display: block;
}

.dropdown .btn {
  width: 100%;
  display: block;
}

</style>
